import { itx } from "../../../src/translationItx/itx";
import React from "react";
import { ButtonRowModeIcon } from "../../../src/components/ButtonRowModeIcon";

export function ButtonRowModeControl({
  x,
  y,
  isSplit,
  rowIndex,
  onToggle,
}: {
  x: number;
  y: number;
  isSplit: boolean;
  rowIndex: number;
  onToggle?: () => void;
}) {
  if (!onToggle) return null;
  const activate = () => onToggle();

  return (
    <g
      className="C1_buttonRowModeControl"
      role="button"
      tabIndex={0}
      aria-label={isSplit ? itx("c1.ui.Zeile_value1_zusammenfuhren", "Zeile {{value1}} zusammenführen", { "{{value1}}": String(rowIndex + 1) }) : itx("c1.ui.Zeile_value1_trennen", "Zeile {{value1}} trennen", { "{{value1}}": String(rowIndex + 1) })}
      onClick={(event) => {
        event.stopPropagation();
        activate();
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          activate();
        }
      }}
    >
      <title>{isSplit ? itx("c1.ui.Zusammenfuhren", "Zusammenführen") : itx("c1.ui.Trennen", "Trennen")}</title>
      <ButtonRowModeIcon x={x} y={y} isSplit={isSplit} />
    </g>
  );
}
